/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import styled from 'styled-components';
import { Form } from 'react-bootstrap';

export const FormLabel = styled(Form.Label)`
    font-size: ${(props: any) =>
        props?.fontScale !== undefined
            ? `${18 + props?.fontScale * 1.5}px`
            : '16px'};
    padding-left: 1rem;
    padding-top: 2%;
    color: ${(props) => props?.color ?? '#000000'};
    font-weight: 500 !important;
`;

export const TweetyForm = styled(Form)`
    background-color: #ffffff;
    padding: 0.5rem 2rem 2rem 2rem;
    // box-shadow:${(props: any) =>
        props?.isNotCard ? '0px' : '0px 0px 10px lightgray'};
`;

export const FeedbackLabel = styled(Form.Control.Feedback)`
    padding-left: 1rem;
    padding-bottom: 1rem;
`;

export const FeedbackOtherLabel = styled(FeedbackLabel)`
    color: red;
    font-size: ${(props: any) =>
        props?.fontScale !== undefined
            ? `${16 + props?.fontScale * 1.5}px`
            : '16px'} !important;
`;

export const FormControl = styled(Form.Control)`
    font-size: ${(props: any) =>
        props?.fontScale !== undefined
            ? `${16 + props?.fontScale * 1.5}px`
            : '16px'} !important;
`;
export const FormSelect = styled(Form.Select)`
    font-size: ${(props: any) =>
        props?.fontScale !== undefined
            ? `${16 + props?.fontScale * 1.5}px`
            : '16px'};
    width: 100%;
    padding: 0.5rem 1rem;
`;
export const FormCheck = styled(Form.Check)`
    font-size: ${(props: any) =>
        props?.fontScale !== undefined
            ? `${16 + props?.fontScale * 1.5}px`
            : '16px'};
`;
